"use client";

import { ApiCart } from "@/api/cart";
import { AddCartResource } from "@/api/generated-api";
import { useAuth } from "@/hooks/useAuth";
import { useStore } from "@/hooks/system/useStore";
import { useMutation } from "@tanstack/react-query";
import { usePathname, useRouter } from "next/navigation";
import { useState } from "react";
import { useProductData } from "./useProductData";
import getQueryClient from "@/stores/getQueryClient";

export const useProductCheckout = () => {
  const { selectedOptionIds } = useStore("catalogDetail");
  const { product } = useProductData();
  const { isAuthenticated } = useAuth();
  const queryClient = getQueryClient();
  const [isAuthOpen, setIsAuthOpen] = useState(false);

  const router = useRouter();
  const pathname = usePathname();

  const { mutate } = useMutation({
    mutationFn: (data: AddCartResource) => ApiCart.postCart(data),
    onSuccess: data => {
      queryClient.setQueryData(["cart"], data);

      router.push("/cart");
    },
  });

  const handleBuyProduct = () => {
    if (!isAuthenticated) {
      setIsAuthOpen(true);
      return;
    }

    mutate({ product_id: product?.id as number, option_ids: Object.values(selectedOptionIds) });
  };

  return {
    product,
    handleBuyProduct,
    authModalProps: {
      open: !isAuthenticated && isAuthOpen,
      onOpenChange: setIsAuthOpen,
      redirectTo: pathname || "/",
    },
  };
};
